import React from 'react';
import { Facebook, Instagram, Linkedin, Twitter, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = ({ t, scrollToSection }) => {
  const quickLinks = [
    { key: 'home', section: 'hero' },
    { key: 'experience', section: 'experience' },
    { key: 'aestheticProducts', section: 'products' },
    { key: 'supplements', section: 'supplements' },
    { key: 'mesomedics', section: 'mesomedics' },
    { key: 'protocols', section: 'protocols' }
  ];

  const socialLinks = [
    { icon: Facebook, url: '#', label: 'Facebook' },
    { icon: Instagram, url: '#', label: 'Instagram' },
    { icon: Linkedin, url: '#', label: 'LinkedIn' },
    { icon: Twitter, url: '#', label: 'Twitter' }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/74bzcw97_SAFEX%20PHARMA%20LOGO%20IMAGEN%20PNG.png" 
              alt="SAFEX PHARMA" 
              className="h-12 w-auto"
            />
            <p className="text-gray-400 leading-relaxed">
              {t.footer.aboutText}
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.url}
                    aria-label={social.label}
                    className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-slate-600 transition-colors duration-300 group"
                  >
                    <Icon className="w-5 h-5 text-white" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">{t.footer.quickLinks}</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.key}>
                  <button
                    onClick={() => scrollToSection(link.section)}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-left"
                  >
                    {t.nav[link.key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">{t.footer.contact}</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${t.footer.email}`} className="text-gray-400 hover:text-white transition-colors">
                  {t.footer.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" />
                <a href={`tel:${t.footer.phone}`} className="text-gray-400 hover:text-white transition-colors">
                  {t.footer.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-slate-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">{t.footer.address}</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-bold mb-6">Newsletter</h3>
            <p className="text-gray-400 mb-4">
              Suscríbete para recibir las últimas novedades y ofertas
            </p>
            <div className="flex flex-col space-y-3">
              <input
                type="email"
                placeholder="Tu email"
                className="px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:border-slate-400 text-white placeholder-gray-400 transition-colors"
              />
              <button className="bg-slate-700 hover:bg-slate-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300">
                Suscribirse
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">{t.footer.rights}</p>
            <div className="flex space-x-6">
              <button className="text-gray-400 hover:text-white text-sm transition-colors">
                {t.footer.privacy}
              </button>
              <button className="text-gray-400 hover:text-white text-sm transition-colors">
                {t.footer.terms}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};